<template>
  <div class="containt">
    <div class="preView-wrapper" v-if="cardDimension.length > 0">
      <div class="form-wrapper">
        <div class="formbox">
          <div class="inp-group" v-for="(item, index) in cardDimension" :key="item.carddimensionId"
            :id="'cardStyleID' + index">
            <span class="title must_inp">
              {{ item.carddimensionName }}
              {{ KDApi.getLangMsg(model, "cardStyle") }}
            </span>
            <div class="inp-box" :style="{ borderColor: editStatus ? '#999' : '#e5e5e5' }">
              <span class="info">
                <input type="text" placeholder="" v-model="item.name" readonly />
              </span>
              <i v-if="editStatus" class="kdfont kdfont-f" @click="getParamsList(item, index)"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="prebox">
        <div class="chart_wrapper" :id="'chartID' + this.chartBoxID"></div>
      </div>
    </div>
    <div class="nodata-tip-wrappper" v-else>
      <div class="nodata-tip-img"></div>
      <div class="text">{{ KDApi.getLangMsg(model, "cardTips") }}</div>
    </div>
  </div>
</template>

<script>
import "../style/style.css";
import KdChart from "./js/kdChart.es";
import { computedCoordinate } from "./js/computedLocation";
import { createPreData, createCardModel, getCardStyle } from "./js/data";

const defaultCardSize = {
  width: 180,
  height: 74,
  xSpace: 36,
  ySpace: 48,
};

export default {
  inject: ["model", "myInvoke", "KDApi"],
  data() {
    return {
      dchart: null,
      treeData: null,
      cardDimension: [],
      currCardDim: null,
      cardstyleMap: {},
      baseCardSize: { ...defaultCardSize },
      cardModelMap: {},
      cardModelSize: {},
      editStatus: true
    };
  },
  created() {
    this.chartBoxID = parseInt(Math.random() * 9999999);
    while (document.getElementById("chartID" + this.chartBoxID)) {
      this.chartBoxID = parseInt(Math.random() * 9999999);
    }
  },
  mounted() { },
  methods: {
    setCardStyles(cardStyle) {
      this.baseCardSize = { ...defaultCardSize };

      this.$set(this.cardDimension, this.currCardDimIndex, {
        ...this.cardDimension[this.currCardDimIndex],
        name: cardStyle.name,
      });

      this.$set(this.cardstyleMap, cardStyle.carddimensionId, cardStyle);

      console.log("cardstyleMap", this.cardstyleMap);

      this.resetCardModel();

      this.$nextTick(() => {
        this.initChart();
        this.initMainView();
      });
    },
    initDim(cardDimension) {

      cardDimension.map((cardItem) => {
        this.cardDimension.push({
          carddimensionId: cardItem.carddimensionId,
          carddimensionName: cardItem.carddimensionName,
          name: cardItem.name || "",
        });

        this.cardstyleMap[cardItem.carddimensionId] = cardItem;
      });

      this.cardDimension.splice(0, 0);

      this.initData();
    },
    resetDim(cardDimension) {

      this.baseCardSize = { ...defaultCardSize };

      const lastCardStyleMap = this.cardstyleMap;

      this.cardstyleMap = {};

      this.cardDimension = cardDimension;

      this.cardDimension.map((item) => {
        if (lastCardStyleMap[item.carddimensionId]) {
          item.name = lastCardStyleMap[item.carddimensionId].name;
          this.cardstyleMap[item.carddimensionId] =
            lastCardStyleMap[item.carddimensionId];
        }
      });

      this.initData();
    },
    initData() {
      if (this.cardDimension.length > 0) {
        this.treeData = createPreData(this.cardDimension);

        this.resetCardModel();
        this.$nextTick(() => {
          this.initChart();
          this.initMainView();
        });
      }
    },
    initChart() {
      const svgWrapperHeight = document.getElementById(
        "chartID" + this.chartBoxID
      ).offsetHeight;

      const svgWrapperWidth = document.getElementById(
        "chartID" + this.chartBoxID
      ).offsetWidth;

      this.kdchart = new KdChart({
        dom: document.getElementById("chartID" + this.chartBoxID),
        treeData: this.treeData,
        computedCoordinate: computedCoordinate,
        baseConfig: {
          swh: svgWrapperHeight,
          sww: svgWrapperWidth,
        },
        pathConfig: {
          elbowRatio: 0.6,
        },
        cardConfig: {
          baseCardSize: this.baseCardSize,
          limitLevel: 3,
        },
        formatData(node) {
          node["name"] = node.data.name;
          node["hasParent"] = node.data.hasParent || false;
          node["hasChild"] = node.data.hasChild || false;
          node["isLeaf"] = node.data.isLeaf || false;
          node["cardStyle"] = getCardStyle(node);
        },
        getCardModel: (node) => {
          return node.data.type;
        },
        getCardSize: (node) => {
          return {
            ...this.baseCardSize,
            height: this.cardModelSize[node.cardModel],
          };
        },
      });
    },
    initMainView() {
      this.kdchart.initMainView({
        toogleBtn: true,
        textTips: true,
        iconConfig: {
          fontSize: 16,
          toogleMinus: {
            unicode: "&#xecb8;",
            color: "#666",
          },
          tooglePlus: {
            unicode: "&#xecb9;",
            color: "#666",
          },
          class: "kdfont",
        },
        cardModel: this.cardModelMap,
      });

      if (this.kdchart.mainView.svgSize.height <= 360) {
        let dy =
          (this.kdchart.mainView.svgSize.height -
            (this.baseCardSize.height * 2 + this.baseCardSize.ySpace)) /
          2 -
          10;

        this.kdchart.mainView.resetGroupLoc({
          rx: 0,
          ry: dy,
        });
      }
    },
    resetCardModel() {
      // console.log(
      //   "---------",
      //   this.KDApi,
      //   this.model,
      //   this.KDApi.getLangMsg(this.model, "card")
      // );
      const [cardModelMap, baseCardSize, cardModelSize] = createCardModel(
        this.cardDimension,
        this.cardstyleMap,
        this.baseCardSize,
        KDApi.getLangMsg(this.model, "card")
      );

      console.log("cardModelMap", cardModelMap);

      this.cardModelMap = cardModelMap;
      this.baseCardSize = baseCardSize;
      this.cardModelSize = cardModelSize;
    },
    getParamsList(currCardDim, index) {
      if (this.editStatus) {
        this.currCardDimIndex = index;
        this.myInvoke("cardstyleselect", {
          carddimensionId: currCardDim.carddimensionId,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.containt {
  width: 100%;
  height: 100%;
  min-height: 360px;
  position: relative;

  .preView-wrapper {
    width: 100%;
    height: 100%;
    display: flex;

    .prebox {
      flex: 1;

      .chart_wrapper {
        width: 100%;
        height: 100%;
        min-height: 360px;
      }
    }

    .form-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;

      .formbox {
        width: 300px;
        min-height: 200px;
        border-right: 1px solid #d9d9d9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .inp-group {
          margin: 15px auto;

          .title {
            font-size: 12px;
            color: rgb(102, 102, 102);
          }

          .inp-box {
            width: 230px;
            height: 26px;
            margin: 2px 0;
            font-size: 14px;
            color: rgb(33, 33, 33);
            display: flex;
            justify-content: space-between;
            align-content: center;
            border-bottom: 1px solid #999;

            input {
              border: none;
              width: 200px;
              height: 24px;
            }
          }
        }
      }
    }
  }

  .nodata-tip-wrappper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .nodata-tip-img {
      width: 256px;
      height: 160px;
      margin: auto;
    }

    .text {
      padding: 15px;
      text-align: center;
    }
  }
}
</style>